import { TextInputField } from '@/components';
import type { FundBusinessFormValues } from '@/features/project/projects/detail/fund-bussiness/_model/fund-business';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const FundBusinessTitleField = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<FundBusinessFormValues>();

  return (
    <TextInputField
      control={control}
      errors={errors}
      label={t('fund-business-title')}
      hint={t('hint-fund-business-subsidy-title')}
      name="title"
      autocompleteKey="fundBusiness.title"
    />
  );
};
